// extracted by mini-css-extract-plugin
export default {"wrap":"ShippingInfoAddModal_wrap__rSfF7","pure":"ShippingInfoAddModal_pure__bo017","button":"ShippingInfoAddModal_button__13F5L"};